<h2 class="c-px mb-3" *ngIf="ribbon.assets && ribbon.assets.length">
    <span class="text-style">{{ribbon.title | translate}}</span>

    <!-- Explore Button -->
    <span class="float-right h4 cursor-po-c"
        *ngIf="ribbon?.hasChildren == true || (ribbon?.hasChildren == false && ribbon?.assets?.length > 9)"
        (click)="explore(ribbon)">{{'gen_more' | translate}}</span>
</h2>
<swiper class="swiper-container ribbon-swiper mb-5" fxFlex="auto" [config]="config"
    *ngIf="ribbon.assets && ribbon.assets.length">
    <div *ngFor="let asset of ribbon.assets" class="swiper-slide">
        <div fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <app-asset-card [asset]="asset" [style]="ribbon.style"></app-asset-card>
        </div>
    </div>
</swiper>